// Importing filter modules
import filtersTaxonomies from './feed.filters.taxonomies';
import filtersDate from './feed.filters.date-range';
import filtersSearch from './feed.filters.search';
import filtersOrder from './feed.filters.order';
import filtersPostType from './feed.filters.post-type';
import filtersPagination from './feed.filters.pagination';
import filtersDraw from './feed.filters.draw';
import filtersUrl from './feed.filters.url';
import filtersLogic from './feed.filters.logic';
import filtersAdvancedSearch from './feed.filters.advanced-search';

/**
 * Initialize the feed filters.
 *
 * @param {Function} callback The callback function to be called after initialization.
 */
const init = async (callback) => {
	// Initialize global filters object with default values
	global.filters = {
		taxonomies: {},
		date_range_from: '',
		date_range_to: '',
		post_types: [],
		query_post_types: false,
		search: '',
		order: 'TitleA',
		page: 1,
		advanced_search: true,
	};

	// Load Initial Filters

	// Initial Taxonomies
	const taxLinks = document.querySelectorAll('.js-gsfc-filter-tax-link');
	if (taxLinks.length > 0) {
		const firstLink = taxLinks[0];
		const value = firstLink.dataset.value;
		const tax = firstLink.dataset.tax;
		const title = firstLink.dataset.title;
		global.filters.taxonomies[tax] = {
			parent: 0,
			terms: [[value, title]],
		};
	}

	// Initial Post Type
	const feedElement = document.querySelector('.js-gsfc-feed');
	const postType = feedElement ? feedElement.dataset.postType : '';
	if (postType && postType !== undefined) {
		global.filters.post_types = [postType];
	}

	// Register listeners
	await filtersUrl(); // Initialize URL filters
	filtersTaxonomies.init(callback); // Initialize taxonomy filters
	filtersDate.init(callback); // Initialize date filters
	filtersSearch.init(callback); // Initialize search filters
	filtersOrder.init(callback); // Initialize order filters
	filtersPostType.init(callback); // Initialize post type filters
	filtersPagination.init(callback); // Initialize pagination filters
	filtersAdvancedSearch.init(callback); // Initialize advanced search filters
	filtersDraw(callback); // Initialize draw filters
	filtersLogic(); // Initialize filter logic
};

/**
 * Update the feed filters.
 *
 * @param {boolean} resetPage Indicates whether to reset the page number.
 */
const update = (resetPage = false) => {
	filtersTaxonomies.update(); // Update taxonomy filters
	filtersDate.update(); // Update date filters
	filtersSearch.update(); // Update search filters
	filtersOrder.update(); // Update order filters
	filtersPostType.update(); // Update post type filters
	filtersPagination.update(resetPage); // Update pagination filters
	filtersAdvancedSearch.update(); // Update advanced search filters
};

// Export initialization and update functions
export default { init, update };
